var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"btn btn-outline-main px-4",attrs:{"type":"button"},on:{"click":function($event){return _vm.$emit('clicked')}}},[_vm._v(" "+_vm._s(_vm.$t(`listing.${_vm.value ? "close" : "open"}`))+" "),_c('b-icon',{staticClass:"ml-1",staticStyle:{"width":"15px"},attrs:{"icon":`chevron-${_vm.value ? 'up' : 'down'}`}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }